/* ==========================================================================
   pdp-vitarub.js
   ========================================================================== */

(function () {
  try {
    if ('name' in document.createElement('details')) return;
    var items = document.querySelectorAll('details[name="vr-acc"]');
    items.forEach(function (d) {
      d.addEventListener('toggle', function () {
        if (!d.open) return;
        items.forEach(function (o) { if (o !== d) o.open = false; });
      });
    });
  } catch (e) { if (window.console) console.warn('[pdp] block failed:', e); }
})();

(function () {
  try {
    var tl = document.querySelector('.tl');
    if (!tl) return;
    if (!('IntersectionObserver' in window)) return;
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    tl.classList.add('is-armed');
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-in');
        io.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px -22% 0px', threshold: 0 });

    Array.prototype.forEach.call(tl.querySelectorAll('.tlstep'), function (step) {
      io.observe(step);
    });
  } catch (e) { if (window.console) console.warn('[pdp] block failed:', e); }
})();

(function () {
  try {
    var CFG = window.__PDP || {};
    var UNIT = CFG.price || 0;
    var FLOOR = +CFG.floor || 0;
    var T2 = +CFG.t2 || 0;
    var T3 = +CFG.t3 || 0;

    var offers = [].slice.call(document.querySelectorAll('#vr-offers .offer'));
    var radios = [].slice.call(document.querySelectorAll('#vr-offers [data-tier-input]'));
    if (!offers.length || !radios.length) return;
    var t3in = document.getElementById('vr-t3-input');
    var t3qty = document.getElementById('vr-t3-qty');
    var t3tot = document.getElementById('vr-t3-total');
    var t3each = document.getElementById('vr-t3-each');
    var t3was = document.getElementById('vr-t3-was');
    var t3ship = document.getElementById('vr-t3-ship');
    var t3name = document.getElementById('vr-t3-name');
    var minus = document.getElementById('vr-minus');
    var plus = document.getElementById('vr-plus');
    var prog = document.getElementById('vr-ship-progress');
    var won = document.getElementById('vr-ship-won');
    var fill = document.getElementById('vr-ship-fill');
    var shipNow = document.getElementById('vr-ship-now');
    var shipGap = document.getElementById('vr-ship-gap');
    var finQty = document.querySelector('[data-fin-qty]');
    var finTot = document.querySelector('[data-fin-total]');
    var finSub = document.querySelector('[data-fin-sub]');
    var finSubDefault = !finSub ? '' : finSub.hasAttribute('data-default') ? finSub.getAttribute('data-default') : finSub.textContent;
    var NOUN = CFG.noun || 'tub';
    var CA = CFG.ca === true;
    var qty3 = 3;

    var FMT = (function (probe) {
      if (!probe) return null;
      var m = String(probe).match(/\d[\d.,'\u00a0\u202f ]*\d|\d/);
      if (!m) return null;
      var core = m[0];
      var tail = core.match(/([^\d])(\d{2})$/);
      var dec = tail ? tail[1] : '';
      var rest = tail ? core.slice(0, core.length - 3) : core;
      var grp = (rest.replace(/\d/g, '')[0]) || '';
      return {
        pre: String(probe).slice(0, m.index), suf: String(probe).slice(m.index + core.length),
        dec: dec, grp: grp, places: dec ? 2 : 0
      };
    })(CFG.probe);

    function group(cents, sep, dec, places) {
      var parts = (Math.abs(cents) / 100).toFixed(places).split('.');
      if (sep) parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, sep);
      return parts.length > 1 ? parts.join(dec) : parts[0];
    }
    function money(cents) {
      if (FMT) return FMT.pre + group(cents, FMT.grp, FMT.dec, FMT.places) + FMT.suf;
      var fmt = CFG.format || '${{amount}}';
      return fmt.replace(/\{\{\s*(\w+)\s*\}\}/g, function (_, token) {
        switch (token) {
          case 'amount_no_decimals': return group(cents, ',', '.', 0);
          case 'amount_with_comma_separator': return group(cents, '.', ',', 2);
          case 'amount_no_decimals_with_comma_separator': return group(cents, '.', ',', 0);
          case 'amount_with_apostrophe_separator': return group(cents, "'", '.', 2);
          default: return group(cents, ',', '.', 2);
        }
      });
    }
    function pctFor(qty) { return qty >= 3 ? T3 : qty === 2 ? T2 : 0; }
    function lineTotal(qty) { var gross = UNIT * qty; return gross - Math.round(gross * pctFor(qty) / 100); }
    function plural(n) { return n + ' ' + (n === 1 ? NOUN : NOUN + 's'); }
    function checkedRadio() {
      return radios.filter(function (r) { return r.checked; })[0] || radios[0];
    }
    function selected() {
      var r = checkedRadio();
      var el = r.closest('.offer') || offers[0];
      var tier = el.getAttribute('data-tier');
      return { el: el, tier: tier, qty: tier === '3' ? qty3 : (parseInt(r.value, 10) || 1) };
    }
    function paint() {
      var sel = selected();
      var total = lineTotal(sel.qty);

      offers.forEach(function (o) { if (o === sel.el) o.setAttribute('data-sel', 'true'); else o.removeAttribute('data-sel'); });

      if (t3in) t3in.value = qty3;
      if (t3qty) t3qty.textContent = qty3;
      if (t3tot) t3tot.textContent = money(lineTotal(qty3));
      if (t3each) t3each.textContent = money(Math.round(lineTotal(qty3) / qty3));
      if (t3was) t3was.textContent = money(UNIT * qty3);
      if (t3ship) t3ship.hidden = !(CA && FLOOR > 0 && lineTotal(qty3) >= FLOOR);
      if (t3name) t3name.textContent = qty3 === 3 ? '3+ ' + NOUN + 's' : plural(qty3);
      if (minus) minus.disabled = qty3 <= 3;

      var atcLabel = document.querySelector('#vr-atc [data-atc-label]');
      if (atcLabel && !atcLabel.hasAttribute('data-busy')) {
        atcLabel.innerHTML = 'Add to cart — <span id="vr-atc-total"></span>';
        atcLabel.querySelector('#vr-atc-total').textContent = money(total);
      }


      if (finQty) finQty.value = sel.qty;
      if (finTot) finTot.textContent = money(total);
      if (finSub) finSub.textContent = sel.qty > 1 ? plural(sel.qty) + ' · ' + money(Math.round(total / sel.qty)) + ' each' : finSubDefault;

      if (CA && FLOOR > 0 && prog && won) {
        var free = total >= FLOOR;
        prog.hidden = free;
        won.hidden = !free;
        if (shipNow) shipNow.textContent = money(total);
        if (!free && fill) fill.style.width = Math.min(100, total / FLOOR * 100).toFixed(1) + '%';
        if (!free && shipGap) shipGap.textContent = money(FLOOR - total) + ' more';
      }
    }
    function track(sel) {
      var P = CFG.product || {};
      if (typeof gtag === 'function') gtag('event', 'select_item', {
        item_list_id: 'pdp_offer_ladder', item_list_name: 'Offer ladder',
        items: [{
          item_id: P.sku || P.variant, item_name: P.title, item_brand: P.vendor,
          price: UNIT / 100, quantity: sel.qty, item_variant: 'tier_' + sel.tier
        }]
      });
    }

    radios.forEach(function (r) {
      r.addEventListener('change', function () { paint(); track(selected()); });
    });
    if (minus) minus.addEventListener('click', function (e) { e.stopPropagation(); e.preventDefault(); if (qty3 > 3) { qty3--; paint(); } });
    if (plus) plus.addEventListener('click', function (e) { e.stopPropagation(); e.preventDefault(); qty3++; paint(); });
    paint();
  } catch (e) { if (window.console) console.warn('[pdp] block failed:', e); }
})();

(function () {
  try {
    var CFG = window.__PDP || {};
    var forms = [].slice.call(document.querySelectorAll('form[action$="/cart/add"]'))
      .filter(function (f) { return f.querySelector('[data-atc]'); });
    if (!forms.length) return;

    function qtyOf(form) {
      var i = form.querySelector('input[name="quantity"]:checked') || form.querySelector('input[name="quantity"]:not([type="radio"])');
      return Math.max(1, parseInt(i && i.value, 10) || 1);
    }
    function fail(form, msg) {
      var box = form.querySelector('[data-atc-error]');
      if (!box) return;
      box.textContent = msg || '';
      box.hidden = !msg;
    }
    function add(form, btn) {
      var label = btn.querySelector('[data-atc-label]') || btn;
      var prev = label.innerHTML;
      var id = form.querySelector('[name="id"]');
      if (!id) return;

      fail(form, '');
      btn.disabled = true;
      label.setAttribute('data-busy', '');
      label.textContent = 'Adding…';

      var body = new FormData();
      body.append('id', id.value);
      body.append('quantity', qtyOf(form));

      fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST', body: body, headers: { 'X-Requested-With': 'XMLHttpRequest' }
      })
        .then(function (r) {
          return r.json().then(function (j) {
            if (!r.ok) throw new Error(j.description || j.message || 'Could not add to cart.');
            return j;
          });
        })
        .then(function (item) {
          var value = (item.final_line_price != null ? item.final_line_price : item.price) / 100;
          var cur = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || CFG.currency;
          if (typeof gtag === 'function') gtag('event', 'add_to_cart', {
            currency: cur, value: value,
            items: [{ item_id: item.sku || item.variant_id, item_name: item.product_title, price: item.price / 100, quantity: item.quantity }]
          });
          if (typeof fbq === 'function') fbq('track', 'AddToCart',
            { content_ids: [item.product_id], content_type: 'product', value: value, currency: cur });
          return fetch(window.Shopify.routes.root + 'cart.js').then(function (r) { return r.json(); });
        })
        .then(function (cart) {
          if (window.emit) {
            window.emit('cart:updated', { cart: cart });
            window.emit('quick-cart:updated');
            window.emit('quick-cart:open');
          } else {
            window.location.href = window.Shopify.routes.root + 'cart';
            return;
          }
          label.textContent = 'Added \u2713';
          setTimeout(function () { label.innerHTML = prev; label.removeAttribute('data-busy'); btn.disabled = false; }, 1800);
        })
        .catch(function (e) {
          fail(form, e.message || 'Could not add to cart. Please try again.');
          label.innerHTML = prev; label.removeAttribute('data-busy'); btn.disabled = false;
        });
    }

    forms.forEach(function (form) {
      form.addEventListener('submit', function (e) {
        var btn = form.querySelector('[data-atc]');
        if (!btn) return;
        e.preventDefault();
        add(form, btn);
      });
    });

    var sticky = document.querySelector('[data-sticky-atc]');
    if (sticky) sticky.addEventListener('click', function () { add(forms[0], forms[0].querySelector('[data-atc]')); });
  } catch (e) { if (window.console) console.warn('[pdp] block failed:', e); }
})();

(function () {
  try {
    var main = document.querySelector('.media__main img');
    var vid  = document.querySelector('.media__main video');
    var thumbs = [].slice.call(document.querySelectorAll('[data-thumb]'));

    var still = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)');
    if (vid && still && still.matches) { vid.removeAttribute('autoplay'); vid.pause(); }

    if (!main || !thumbs.length) return;

    function mark(btn) {
      thumbs.forEach(function (t) { t.removeAttribute('aria-current'); });
      btn.setAttribute('aria-current', 'true');
    }

    function show(btn) {
      if (vid && btn.getAttribute('data-thumb-video') === 'true') {
        main.hidden = true;
        vid.hidden = false;
        var p = vid.play();
        if (p && p.catch) p.catch(function () {});
        mark(btn);
        return;
      }
      var src = btn.getAttribute('data-thumb');
      if (!src) return;
      if (vid) { vid.pause(); vid.hidden = true; }
      main.hidden = false;
      main.removeAttribute('srcset');
      main.removeAttribute('sizes');
      main.src = src;
      mark(btn);
    }

    thumbs.forEach(function (btn) {
      btn.addEventListener('click', function (e) { e.preventDefault(); show(btn); });
      btn.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); show(btn); }
      });
    });
  } catch (e) { if (window.console) console.warn('[pdp] block failed:', e); }
})();

(function () {
  try {
    var bar = document.querySelector('[data-sticky-bar]');
    var atc = document.getElementById('vr-atc');
    var fin = document.getElementById('buy');
    if (!bar || !atc || !('IntersectionObserver' in window)) return;
    var btn = bar.querySelector('[data-sticky-atc]');
    var atcGone = false, finSeen = false;
    function apply() {
      var on = atcGone && !finSeen;
      bar.classList.toggle('is-on', on);
      bar.setAttribute('aria-hidden', on ? 'false' : 'true');
      if (btn) btn.tabIndex = on ? 0 : -1;
    }
    new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { atcGone = !e.isIntersecting && e.boundingClientRect.top < 0; });
      apply();
    }, { threshold: 0 }).observe(atc);
    if (fin) new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { finSeen = e.isIntersecting; });
      apply();
    }, { threshold: 0.15 }).observe(fin);
  } catch (e) { if (window.console) console.warn('[pdp] block failed:', e); }
})();

(function () {
  try {
    var CFG = window.__PDP || {};
    if (CFG.view !== true || window.__PDP_VIEWED) return;
    window.__PDP_VIEWED = true;
    var P = CFG.product || {};
    var cur = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || CFG.currency;
    var price = (CFG.price || 0) / 100;
    if (typeof gtag === 'function') gtag('event', 'view_item', {
      currency: cur, value: price,
      items: [{ item_id: P.sku || P.variant, item_name: P.title, item_brand: P.vendor, price: price, quantity: 1 }]
    });
    if (typeof fbq === 'function') fbq('track', 'ViewContent',
      { content_ids: [String(P.id)], content_name: P.title, content_type: 'product', value: price, currency: cur });
  } catch (e) { if (window.console) console.warn('[pdp] block failed:', e); }
})();
